import miroLogo from './images/miro.png';
import slackLogo from './images/slack.png';
import invisonLogo from './images/invision.png';
import googleDriveLogo from './images/google-drive.png';
import lucidChartLogo from './images/lucidchart.png';
import { getSlackConsentUrl } from './utils';

export interface PromotedIntegration {
	key: string;
	actionSubjectId: string;
	label: string;
	icon: string;
	getUrl: (source: string, isAdmin: boolean) => string;
	shouldOpenPopup?: boolean;
	getMarketplaceUrl: (source: string, isAdmin: boolean) => string;
}

export interface IntegrationToShow extends PromotedIntegration {
	url: string;
	marketplaceUrl: string;
}

const SLACK = 'confluence-slack-integration';
const GOOGLE_DRIVE = 'confluence-google-drive';
const LUCID_CHART = 'com.lucidchart.confluence.plugins.lucid-confluence';
const MIRO = 'com.realtimeboard.plugins.confluence-server-plugin';
const INVISON = 'confluence-invisionapp-addon';

const marketplaceUrlFactory =
	(key: string, openInstallDialog: boolean, hasInstallDialog = true) =>
	(source: string, isAdmin: boolean) =>
		`/wiki/plugins/servlet/ac/com.atlassian.confluence.emcee/enduser-discover#!/discover/app/${key}?${new URLSearchParams(
			{
				source,
				...(openInstallDialog
					? isAdmin
						? hasInstallDialog
							? { installDialogOpen: 'true' }
							: undefined
						: { requestDialogOpen: 'true' }
					: undefined),
			},
		).toString()}`;

export const slackIntegration: PromotedIntegration = {
	key: `${SLACK}-key`,
	actionSubjectId: 'slackForAtlassianApp',
	icon: slackLogo,
	label: 'Slack',
	getUrl: (source) => getSlackConsentUrl(source),
	shouldOpenPopup: true,
	getMarketplaceUrl: marketplaceUrlFactory(SLACK, false),
};

export const promotedIntegrations: PromotedIntegration[] = [
	slackIntegration,
	{
		key: `${GOOGLE_DRIVE}-key`,
		actionSubjectId: 'googleDriveApp',
		icon: googleDriveLogo,
		label: 'Google Drive',
		getUrl: marketplaceUrlFactory(GOOGLE_DRIVE, true),
		getMarketplaceUrl: marketplaceUrlFactory(GOOGLE_DRIVE, false),
	},
	{
		key: `${LUCID_CHART}-key`,
		actionSubjectId: 'lucidchartApp',
		icon: lucidChartLogo,
		label: 'Lucidchart',
		getUrl: marketplaceUrlFactory(LUCID_CHART, true, false),
		getMarketplaceUrl: marketplaceUrlFactory(LUCID_CHART, false, false),
	},
	{
		key: `${MIRO}-key`,
		actionSubjectId: 'miroApp',
		icon: miroLogo,
		label: 'Miro',
		getUrl: marketplaceUrlFactory(MIRO, true),
		getMarketplaceUrl: marketplaceUrlFactory(MIRO, false),
	},
	{
		key: `${INVISON}-key`,
		actionSubjectId: 'invisonApp',
		icon: invisonLogo,
		label: 'InVision',
		getUrl: marketplaceUrlFactory(INVISON, true),
		getMarketplaceUrl: marketplaceUrlFactory(INVISON, false),
	},
];
